import Vue from 'vue';

import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    isLoginSuccess:localStorage.getItem('isLoginSuccess'),//是否登录
  },
  mutations:{
    changeState:state => state.isLoginSuccess = localStorage.getItem('isLoginSuccess'),
  }
})